import { render, staticRenderFns } from "./bufenShouKuan.vue?vue&type=template&id=3dc03ff4&scoped=true&"
import script from "./bufenShouKuan.vue?vue&type=script&lang=js&"
export * from "./bufenShouKuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc03ff4",
  null
  
)

export default component.exports